import { api } from "../../../api";

export class CMDBService {
  async fetchServerStats() {
    return await api("/cmdb/servers/stats");
  }

  async fetchServers({ limit, offset, search, status }) {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    });
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    return await api(`/cmdb/servers?${params}`);
  }

  async fetchTopology() {
    return await api("/cmdb/topology");
  }

  async fetchAssetHealthSummary(period = "7d") {
    return await api(`/cmdb/asset-health-summary?period=${period}`);
  }
}

export const cmdbService = new CMDBService();

export const fetchServerStats = () => cmdbService.fetchServerStats();
export const fetchServers = (params) => cmdbService.fetchServers(params);
export const fetchTopology = () => cmdbService.fetchTopology();
export const fetchAssetHealthSummary = (period) => cmdbService.fetchAssetHealthSummary(period);
